/**
 * LocalStorage keys used by the Sales Coach dashboard frontend.
 *
 * Namespace rule (D-15): every key is prefixed `sc_dashboard_` to avoid
 * collision if this frontend and black-mirror ever share the same origin.
 * Matches Phase 3 D-04 namespace for AUTH_TOKEN.
 */

export enum StorageKey {
  AUTH_TOKEN = 'sc_dashboard_auth_token',
  THEME_MODE = 'sc_dashboard_theme_mode',
  /**
   * Bug D16 — last-used Filters (including granularity + includeWeekends),
   * JSON-serialised via FilterSchema. Restored on mount when the URL has
   * no filter params; URL always wins over storage so deep links stay
   * canonical. Dropped silently on zod parse failure (schema drift).
   */
  FILTERS = 'sc_dashboard_filters',
}
